import React, { useState, useEffect } from 'react';

interface NetworkDiagnosticProps {
  show?: boolean;
}

export const NetworkDiagnostic: React.FC<NetworkDiagnosticProps> = ({ show = false }) => {
  const [diagnostics, setDiagnostics] = useState<Array<{
    name: string;
    url: string;
    endpoint: string;
    status: number;
    ok: boolean;
    error: string | null;
  }>>([]);
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    if (!isVisible) return;

    const checkAPIs = async () => {
      const apis = [
        {
          name: 'Auth API',
          url: import.meta.env.VITE_API_URL,
          endpoint: '/health'
        },
        {
          name: 'Source API',
          url: import.meta.env.VITE_API_SOURCE_URL,
          endpoint: '/health'
        },
        {
          name: 'Projects API',
          url: import.meta.env.VITE_PROJECTS_API,
          endpoint: '/health'
        }
      ];

      const results = await Promise.allSettled(
        apis.map(async (api) => {
          try {
            const response = await fetch(`${api.url}${api.endpoint}`, {
              method: 'GET',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
              },
            });
            return {
              ...api,
              status: response.status,
              ok: response.ok,
              error: null
            };
          } catch (error) {
            return {
              ...api,
              status: 0,
              ok: false,
              error: error instanceof Error ? error.message : 'Unknown error'
            };
          }
        })
      );

      setDiagnostics(results.map((result, index) => {
        if (result.status === 'fulfilled') {
          return result.value;
        } else {
          const api = apis[index];
          return {
            ...api,
            status: 0,
            ok: false,
            error: 'Failed to check',
          };
        }
      }));
    };

    checkAPIs();
  }, [isVisible]);

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          padding: '10px',
          backgroundColor: '#17a2b8',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '16px',
          zIndex: 1000
        }}
        title="Mostrar diagnóstico de red"
      >
        🔍
      </button>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: 'white',
      border: '1px solid #ddd',
      borderRadius: '8px',
      padding: '15px',
      maxWidth: '400px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      zIndex: 1000,
      fontSize: '14px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4 style={{ margin: 0 }}>🔍 Diagnóstico de Red</h4>
        <button 
          onClick={() => setIsVisible(false)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}
        >
          ✕
        </button>
      </div>

      <div style={{ marginBottom: '15px' }}>
        <strong>Variables de Entorno:</strong>
        <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
          <div>API_URL: {import.meta.env.VITE_API_URL || '❌ No configurada'}</div>
          <div>API_SOURCE_URL: {import.meta.env.VITE_API_SOURCE_URL || '❌ No configurada'}</div>
          <div>PROJECTS_API: {import.meta.env.VITE_PROJECTS_API || '❌ No configurada'}</div>
        </div>
      </div>

      <div>
        <strong>Estado de APIs:</strong>
        {diagnostics.map((api, index) => (
          <div key={index} style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            padding: '5px 0',
            borderBottom: '1px solid #eee'
          }}>
            <span>{api.name}</span>
            <span style={{ 
              color: api.ok ? 'green' : 'red',
              fontSize: '12px'
            }}>
              {api.ok ? '✅ OK' : `❌ ${api.status || 'Error'}`}
            </span>
          </div>
        ))}
      </div>

      <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
        <strong>Navegador:</strong> {navigator.userAgent.split(' ').slice(-2).join(' ')}
      </div>
    </div>
  );
};